import * as React from 'react';

import classnames from 'classnames';

import {RemoveButton} from '../button/remove-button/remove-button';

import {getEntityClassName} from './helpers';
import type {SectionEntity} from './types';

import styles from './adding-item-container.module.css';

type Props = {
    children: React.ReactNode;
    sectionEntity: SectionEntity;
    onClickRemove: (arg1?: any) => any;
};

export function AddingItemContainer(props: Props) {
    const {children, sectionEntity, onClickRemove} = props;

    const addItemStyleNames = classnames({
        [styles['adding-item-container']]: true,
        ...getEntityClassName(sectionEntity),
    });

    return (
        <div className={addItemStyleNames}>
            <div className={styles['add-item-component']}>{children}</div>
            <div className={styles['remove-button-container']}>
                <RemoveButton size={10} onClick={onClickRemove} />
            </div>
        </div>
    );
}
